import { deviceSpec } from "breakpoints";
import { styled } from "styled-components";


export const InputContainer = styled('div')`
    border: 1px;
    
    .placeholder-text {
        color: #666;
        pointer-events: none;
        user-select: none;
    }

    background-color: ${({ theme }) => theme.colors.userInputBg};

    path {
        color: ${({theme}) => theme.colors.textColor};
    }

    @media ${deviceSpec.isMobile} {
        width: 100% !important; 
    }
`;

export const AnimatePresenceContainer = styled('div')`
    position: absolute;
`

export const EditableTextBox = styled('span')`
    p, span {
        color: ${({theme}) => theme.colors.textColor};
    }
`